import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton, Wizmessage } = component_tool
const { WizContainer, WizFileUpload } = framework_tool
const { Session } = utils_tool
import { WizBraftEditorPlus } from '@/containers/common'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/onlineNotification/sendNotification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('sendNotification', record)
        } else {
            record = Session.get('sendNotification') || {}
        }
    }
    return record
}

const validator = (rule, value, callback) => {
    if (value && value !== '<p></p>') {
        callback()
        return
    }
    callback('请输入启动函')
}

class SendNotification extends WizContainer {

    componentName = 'SendNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId, state } = this.state.record
        if (state !== 1) {
            this.doAction({
                path: 'counselingProcess/noticeDetail',
                payload: {
                    key: 'noticeDetail@' + processContentId,
                    apiParams: {
                        tutorContentId: processContentId
                    }
                }
            })
        }
    }

    _onSub = () => {
        const { processContentId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { files = [], startDetail } = values
                let { fileId } = files[0] || {}
                let params = {
                    startDetail,
                    fileId,
                    tutorContentId: processContentId
                }
                this.doAction({
                    path: 'counselingProcess/sendNotice',
                    payload: {
                        key: 'sendNotice@' + processContentId,
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { data } = detail
        let columns = [{
            title: '启动函',
            name: 'startDetail',
            dataIndex: 'startDetail',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    return getFieldDecorator('startDetail', {
                        initialValue: r ? r.startDetail : undefined,
                        rules: [{ required: true, validator }]
                    })(<WizBraftEditorPlus links={[0, 1, 2, 3]} />)
                }
            },
        }, {
            title: '内训资料包',
            name: 'files',
            dataIndex: 'files',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    let initialValue = []
                    if (r && r.fileId && r.fileId != -1) {
                        initialValue = [{ fileId: r.fileId }]
                    }
                    return getFieldDecorator('files', {
                        initialValue,
                        rules: [{ required: true, message: '请上传内训资料包' }]
                    })(
                        <WizFileUpload
                            accept={'.zip, .rar'}
                            listType={'text'}
                            limit={-1}
                            progress={{
                                strokeColor: { '0%': '#108ee9', '100%': '#87d068' },
                                strokeWidth: 3,
                                format: percent => `${parseFloat(percent.toFixed(2))}%`,
                            }}
                        />
                    )
                }
            },
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: data,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='下发启动通知'>
                    <WizForm key={data ? data.id : 'send'} {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'noticeDetail@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'sendNotice@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(SendNotification)


